import { useSecureGraphqlMutation } from '@psyomics/ui-common';
import { useCallback } from 'react';

import {
  CancelReferralRequestDocument,
  CancelReferralRequestMutation,
  CancelReferralRequestMutationVariables,
} from '../../generated/home';

const useCancelReferralRequest = () => {
  const [{ fetching: cancelling }, executeCancel] = useSecureGraphqlMutation<
    CancelReferralRequestMutation,
    CancelReferralRequestMutationVariables,
    'ReferralRequestNotCancellable'
  >(CancelReferralRequestDocument, ['ReferralRequestNotCancellable' as const]);

  const cancelReferralRequest = useCallback(
    async (id: string) => {
      const result = await executeCancel({ id });
      return !result.error;
    },
    [executeCancel]
  );

  return { cancelling, cancelReferralRequest };
};

export { useCancelReferralRequest };
